import { EInvoiceConsentDataServerVM } from "./eInvoiceConsentDataServerVM";

export interface ViewModel {
  consent: boolean;
  eMail1: string | null;
  eMail2: string | null;
}

export function toServerVM(vm: ViewModel): EInvoiceConsentDataServerVM {
  // normalize the empty e-mails to null
  let r: EInvoiceConsentDataServerVM = {
    consent: vm.consent,
    eMail1: !!vm.eMail1? vm.eMail1: null,
    eMail2: !!vm.eMail2? vm.eMail2: null,
  };

  return r;
}

export function serverVMToClientVM(vm: EInvoiceConsentDataServerVM): ViewModel {
  let r: ViewModel = {
    consent: false,
    eMail1: vm.eMail1,
    eMail2: vm.eMail2,
  };

  return r;
}

export const viewModelNewValues: ViewModel = {
  consent: false,
  eMail1: null,
  eMail2: null,
};
